<template>
    <div id="org_settings_connections">
        <div id="org_settings_connections_notifications" class="row mb-3"  v-if="!if_viewing_connection && unconnected_integration !== false">
            <div class="col-md-7 col-12 mb-3 pe-md-3 pe-0">
                <div class="card h-100">
                    <div class="card-body d-flex">
                        <div class="d-none d-lg-flex flex-column justify-content-center">
                            <canvas id="integration_completion_precentage" class="pie-chart"></canvas>
                        </div>
                    
                        <div class="ms-4 integration-list">
                            <h4>Avid Integration Checklist:</h4>
                            <p class="mb-2">Each integration that you connect allows Avid to derive deeper insights and better recommendations.</p>

                            <p class="mb-2" v-for="type in integration_types" :key="type">
                                <img v-if="connected_integration_list[type] != undefined" class="icon green-icon me-2" src="/img/icons/avid-icons/tick-circle.svg" alt="Connected">
                                <img v-else class="icon red-icon me-2" src="/img/icons/avid-icons/danger.svg" alt="Not Connected">
                                <span v-if="connected_integration_list[type] != undefined">{{ getIntegrationLabel(type) }} <em>({{connected_integration_list[type] }})</em></span>
                                <a v-else-if="canEdit('connections')" href="#" @click.prevent="addSystemByIntegrationType(type)" >{{ getIntegrationLabel(type) }}</a>
                                <a v-else >{{ getIntegrationLabel(type) }}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5 col-12 mb-3 ps-md-3 ps-0">
                <div class="card h-100">
                    <div class="card-body m-2">
                        <div class="row">
                            <!-- Column for the icon -->
                            <div class="col-auto d-none d-lg-block"> <!-- Use col-auto to fit the content's width -->
                                <img src="/img/icons/avid-icons/plug-connected.svg" class="modal-icon" alt="Connection Icon">
                            </div>
                            <!-- Column for text and button -->
                            <div class="col ps-3">
                                <h4>Connect your {{getIntegrationLabel(unconnected_integration)}} System</h4>
                                <p class="mb-3">{{getIntegrationReasoning(unconnected_integration)}}</p>
                                <div v-if="!canEdit('connections')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                    <button class="btn btn-secondary" :disabled="true">
                                        <img class="icon" src="/img/icons/avid-icons/plus.svg" alt="Add">
                                        Connect Your {{getIntegrationLabel(unconnected_integration)}}
                                    </button>
                                </div>
                                <button v-else class="btn btn-secondary" @click.prevent="addSystemByIntegrationType(unconnected_integration)">
                                    <img class="icon" src="/img/icons/avid-icons/plus.svg" alt="Add">
                                    Connect Your {{getIntegrationLabel(unconnected_integration)}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <h3 class="mb-1">Connections</h3>
            <p class="mb-3">
                To get a full 360-degree view of your organization, you need to connect all of the systems that provide insight into your donors' behavior. Upload files or connect more systems below.
            </p>
        </div>

        <div class="card p-3" v-if="!if_viewing_connection">

            <nav class="navbar navbar-expand tertiary-tab-bar d-flex">
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav mb-lg-0">
                        <li class="nav-item" v-for="(tab_name, index) in connection_tabs">
                            <a class="nav-link d-flex flex-nowrap tertiary-tab"
                            :class="{'tertiary-tab-active': index==connection_tab_index_active}"
                            href="#" role="button" aria-expanded="false" @click.prevent="setActiveTab(index)">
                                <span>{{ tab_name }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
       

            <div class="row mt-3">
                <connections-settings-systems v-if="connection_tab_index_active == 0" :client="client" :integrations="integrations" 
                :connections="local_connections" @viewConnection="viewConnection" @updateConnection="updateConnection" @addSystem="addSystem"></connections-settings-systems>

                <connections-settings-files v-if="connection_tab_index_active == 1" :client="client" :files="local_files" :num_files="num_files" :file_connection="file_connection"
                @viewFile="viewFile" @openAddFileModal="openAddFileModal" ></connections-settings-files>

                <data-blends v-if="connection_tab_index_active == 2 && user.user_type === 'admin'" :client="client" :datablends="datablends"></data-blends>
            </div>
        </div>

        <div v-else>
            <div>
                <button class="btn btn-white back-button" @click.prevent="backToSelection()">
                    <img class="icon" src="/img/icons/avid-icons/chevrons-left.svg" alt="Back">
                    Back
                </button>   
            </div>
            <connections-settings-view-dataset :user="user" :client="client" :selected_connection_or_file="selected_connection_or_file" :all_datasets="all_datasets_for_client" @delete-connection="handleDeleteConnection"></connections-settings-view-dataset>
        </div>

        <system-modal ref="systemModal" :id="'connections-setting-system-modal'" :client="client" :integrations="local_intergation_list" :connections="local_connections"
            :connection_selected="connection_selected" @connectionAdded="addConnection" @resetModal="resetModal"></system-modal>
        
        <!-- File Modal -->
        <div class="modal fade" id="file-modal" aria-labelledby="file-modal" data-bs-backdrop="static">
            <div class="modal-dialog modal-lg">
               <div class="modal-content mx-2">
                    <div class="modal-header border-bottom-0">
                        <div class="w-100 d-flex flex-column gap-1">
                            <h2 class="mb-0 mt-2">Add Data Files</h2>
                        </div>
                        <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="file-modal" @click="closeFileModal" data-bs-toggle="tooltip" title="Close">
                            <img class="icon me-0" src="/img/icons/avid-icons/close.svg" alt=""> 
                        </button>
                    </div>
                    <div class="modal-body pt-0">
                        <file-modal 
                            v-if="file_connection"
                            :client="client" 
                            :connection="file_connection" 
                            :is-in-modal="true"
                            @closeModal="closeFileModal"
                        ></file-modal>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import permissionsMixin from '../../mixins/permissions'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { defineComponent } from 'vue';
import DataBlends from './DataBlends.vue';

export default defineComponent({

    mixins: [permissionsMixin],
    components: {
        DataBlends
    },
    props: ['user', 'client', 'tab_name', 'integrations', 'connections', 'datablends', 'files', 'num_files'],
    data() {
        return {
            connection_tabs: ['Systems', 'Files'],
            connection_tab_index_active: 0,
            integration_types: ['crm', 'email', 'advertising', 'email_form', 'analytics'],
            local_intergation_list: [],
            connected_integration_list: [],
            chart: null,
            local_files: [],
            file_connection: null,
            if_viewing_connection: false,
            selected_connection_or_file: {}, // this can be either connection or file
            connection_id: null,
            file_id: null,
            connection_selected: null,
            local_connections: [], 
            all_datasets_for_client: []
        };
    },
    beforeMount() {
        this.local_connections = this.connections || [];
        this.local_intergation_list = this.integrations || [];
        this.file_connection = (this.connections || []).find(conn => conn.integration_id == '71b0c3b0-8390-49ec-9984-1c04b7384d38') || null;
        this.local_files = this.files || [];
        this.getAllDatasets();
        this.setScreen();

        if(this.user.user_type === 'admin' && this.datablends && this.datablends.length > 0) {
            this.connection_tabs.push('Data Blends');
        }
    },
    mounted() {
        window.addEventListener('popstate', this.handlePopState);

        this.renderChart(true);
    },
    watch: {
        // Watch for when the component becomes visible (when switching to Connections tab)
        '$parent.setting_tab_name_active': {
            handler(newTab) {
                if (newTab === 'Connections') {
                    this.$nextTick(() => {
                        this.renderChart(false);
                    });
                }
            },
            immediate: false
        },
        connections: {
            handler(newConnections) {
                if (newConnections && newConnections.length > 0) {
                    this.local_connections = newConnections;
                    this.file_connection = newConnections.find(conn => conn.integration_id == '71b0c3b0-8390-49ec-9984-1c04b7384d38') || null;
                    this.getAllDatasets();
                    this.setScreen();
                }
            },
            deep: false
        },
        integrations: {
            handler(newIntegrations) {
                if (newIntegrations && newIntegrations.length > 0) {
                    this.local_intergation_list = newIntegrations;
                }
            },
            deep: false
        },
        files: {
            handler(newFiles) {
                if (newFiles) {
                    this.local_files = newFiles;
                }
            },
            deep: false
        },
        datablends: {
            handler(newDatablends) {
                if (this.user.user_type === 'admin' && newDatablends && newDatablends.length > 0 && !this.connection_tabs.includes('Data Blends')) {
                    this.connection_tabs.push('Data Blends');
                }
            },
            deep: false
        },
        tab_name: {
            handler(newTabName) {
                if (newTabName === 'data_blends') {
                    this.connection_tab_index_active = 2;
                } else if (newTabName === 'files') {
                    this.connection_tab_index_active = 1;
                } else if (newTabName === 'integrations') {
                    this.connection_tab_index_active = 0;
                }
            }
        }
    },

    computed: {
        unconnected_integration() {
            //Filter based upon the connect_integration_list keys
            var unconnected = this.integration_types.filter(element =>
                !Object.keys(this.connected_integration_list).includes(element)
            );

            if(unconnected == null || unconnected.length == 0)
                return false;

            return unconnected[0];
        }
    },
    beforeDestroy() {
        window.removeEventListener('popstate', this.handlePopState);
        // Clean up chart instance
        if (this.chart) {
            try {
                this.chart.destroy();
            } catch (error) {
                // Ignore errors during cleanup
            }
            this.chart = null;
        }
        // Also check for any chart registered on the canvas
        const ctx = document.getElementById('integration_completion_precentage');
        if (ctx) {
            const existingChart = Chart.getChart(ctx);
            if (existingChart) {
                try {
                    existingChart.destroy();
                } catch (error) {
                    // Ignore errors during cleanup
                }
            }
        }
    },
    methods: {
        getAllDatasets(){
            // load all dataset to pass into join builder 
            let temp = [];
            this.connections.forEach((conn)=>{
                temp = temp.concat(conn.datasets);
            })
            this.all_datasets_for_client = temp;
        },
        getIntegrationLabel(type){
            if(type == 'crm')
                return 'CRM';
            if(type == 'email')
                return 'Email Marketing';
            if(type == 'email_form')
                return 'Email Capture';
            if(type == 'advertising')
                return 'Advertising';
            if(type == 'analytics')
                return 'Analytics';
        },
        getIntegrationReasoning(type){
            if(type == 'crm')
                return 'Avid is designed to analyze your fundraising and marketing efforts. The most important part of this analysis is understanding your donors\' history and what activities produce the best behaviors.';
            if(type == 'email')
                return 'A key aspect to understanding a donor\'s motivation is analyzing what separates them from similar individuals who aren\'t giving. Avid can help you understand what messages drive the best behavior and the key differences between existing donors and subscribers on your email file.';
            if(type == 'email_form')
                return 'Understanding what drives your subcribers and donors to "opt in" can provide insights about what content they find most valuable. It also allows Avid to track the progress from initial opt in to downstream conversion.';
            if(type == 'advertising')
                return 'Avid can help you understand the effectiveness of your advertising campaigns. This includes understanding the full impact of your advertising on donor behavior and the effectiveness of your advertising spend.';
            if(type == 'analytics')
                return 'Your web analytics platform can provide insights into what content is most popular and can give you ideas for ways to expand your audience. This can lead to new acquisition ideas and better cultivation of your existing donors.';
        },
        setScreen() {
            const params = new URLSearchParams(window.location.search);
            if(params.get('connection') != null){
                this.connection_id = parseInt(params.get('connection'));
                this.connection_tab_index_active = 0;

                // check if connection id exists in the connection array
                var index = this.local_connections.findIndex(conn => conn.id == this.connection_id);
                if(index >= 0){
                    this.if_viewing_connection = true;
                    this.selected_connection_or_file = this.local_connections[index];
                } else {
                    var newURL = '/settings/'+this.client.url +'/integrations';
                    window.history.replaceState({}, {}, newURL);
                }
            }
            else if(params.get('file') != null){
                this.file_id = parseInt(params.get('file'));
                this.connection_tab_index_active = 1;

                // check if connection id exists in the connection array
                var index = this.local_files.findIndex(file => file.id == this.file_id);
                if(index >= 0){
                    this.if_viewing_connection = true;
                    this.selected_connection_or_file = this.local_files[index];
                } else {
                    var newURL = '/settings/'+this.client.url +'/files';
                    window.history.replaceState({}, {}, newURL);
                }
            } else {
                this.if_viewing_connection = false;
                //If the url contains /files
                if (window.location.href.includes('/files')){
                    this.connection_tab_index_active = 1;
                }
                else if (window.location.href.includes('/data_blends')){
                    this.connection_tab_index_active = 2;
                }
                else{
                    this.connection_tab_index_active = 0;
                }
            }
            this.setConnectedIntegrations();
            this.$forceUpdate();
        },
        setConnectedIntegrations(){
            var connected_integrations = [];
            this.connections.forEach((conn) => {
                conn.integration.integration_types.forEach((integration) =>{

                    //TODO If it is other, check the data sets attached to it
                    if(integration == 'other' && conn.datasets && Array.isArray(conn.datasets) && conn.datasets.length > 0) {
                        conn.datasets.forEach((dataset) => {
                            let type = '';
                            if(dataset.source_subtype == 'transactions' || dataset.source_subtype == 'constituents' )
                                type = 'crm';
                            else if(dataset.source_subtype == 'email_form')
                                type = 'email_form';

                            if(type != '') {
                                //If the type hasn't been added at all
                                if(connected_integrations[type] == undefined)
                                    connected_integrations[type] = conn.integration.display_name;
                                //Make sure it wasn't already added
                                else if(connected_integrations[type].indexOf(conn.integration.display_name) == -1)
                                    connected_integrations[type] += ", " + conn.integration.display_name;
                            }
                        });

                        return;
                    }

                    if(this.integration_types.includes(integration) == false)
                        return;
                    //Do the
                    if(connected_integrations[integration] == undefined)
                        connected_integrations[integration] = conn.integration.display_name;
                    else
                        connected_integrations[integration] += ", " + conn.integration.display_name ;
                })
            })
            this.connected_integration_list = connected_integrations;
            
        },
        renderChart(animate) {
            var connection_count= Object.keys(this.connected_integration_list).length;
            var completed_precentage = 100* connection_count / this.integration_types.length; 
    
            const data = {
            labels: [
                'Completed',
                'Incomplete',
            ],
            datasets: [{
                label: 'Connection Completion',
                data: [ connection_count, this.integration_types.length - connection_count],
                backgroundColor: ['rgb(34, 117, 81)', 'rgb(209, 31, 31)'],
                color: ['rgb(255, 255, 255)', 'rgb(255, 255, 255)']
                }]
            };
            var options = {
                type: 'doughnut',
                plugins: [ChartDataLabels],
                data: data,
                options: {
                    responsive: true,
                    //    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        tooltip: { display: false },
                        datalabels: { display: false },
                        textInside: {
                            title: completed_precentage.toString() + '%',
                            titleColor: 'black',
                            titleSize: 28,
                        //    text: 'completed',
                        //     textColor: 'black',
                        //     textSize: 18, 
                        }
                    },
                    // Make the doughnut ring thinner by increasing the inner cut-out radius
                    cutout: '70%',
                    animation: {
                        duration: (animate ? 500 : 0) // Disable animations by setting duration to 0
                    },
                    title: { display: false },
                },
            };
            
            // Destroy any existing chart instance
            if(this.chart != null) {
                try {
                    this.chart.destroy();
                } catch (error) {
                    // Ignore errors during cleanup
                }
                this.chart = null;
            }

            var ctx = document.getElementById('integration_completion_precentage');
            if(ctx != undefined) {
                // Check if Chart.js has a chart registered on this canvas
                const existingChart = Chart.getChart(ctx);
                if (existingChart) {
                    try {
                        existingChart.destroy();
                    } catch (error) {
                        // Ignore errors during cleanup
                    }
                }
                this.chart = new Chart(ctx, options);
            }
                
        },
        setActiveTab(index){
            this.connection_tab_index_active = index;
            
            var newURL = '/settings/'+this.client.url+'/';

            if (index == 0){
                newURL += 'integrations';
            } else if (index == 1){
                newURL += 'files';
            } else if (index == 2){
                newURL += 'data_blends';
            } 
            window.history.pushState({}, {}, newURL);
            this.$forceUpdate();
        },
        viewConnection(conn){
            this.if_viewing_connection = true;
            this.selected_connection_or_file = conn;
            if (this.selected_connection_or_file.datasets && this.selected_connection_or_file.datasets.length >1){
                this.selected_connection_or_file.datasets.sort((a, b) => (a.name > b.name) ? 1 : -1); 
            }

            var newURL = '/settings/'+this.client.url+'/integrations?connection='+conn.id;
            window.history.pushState({}, '', newURL);
        },
        viewFile(file){
            this.if_viewing_connection = true;
            this.selected_connection_or_file = file;

            var newURL = '/settings/'+this.client.url+'/files?file='+file.id;
            window.history.pushState({}, {}, newURL);
        },
        openAddFileModal(){
            var modal = new bootstrap.Modal(document.getElementById('file-modal'));
            modal.show();
        },
        backToSelection(){
            this.if_viewing_connection = false;
            var newURL;
            if(this.selected_connection_or_file.datasets!= undefined){
                newURL = '/settings/'+this.client.url+'/integrations';
            } else if (this.connection_tab_index_active == 2) {
                newURL = '/settings/'+this.client.url+'/data_blends';
            } else {
                newURL = '/settings/'+this.client.url+'/files';
            }
            this.selected_connection_or_file = {};
            window.history.replaceState({}, {}, newURL);
            //Next tick
            this.$nextTick(() => { this.renderChart(false); });
        },
        addSystem(){
            this.connection_selected = null;
            this.local_intergation_list = this.integrations;
            var modal = new bootstrap.Modal(document.getElementById('connections-setting-system-modal'));
            modal.show();
        },
        addSystemByIntegrationType(integration_type){
            this.addSystem();
            
            // Pass the integration type to the modal for filter preselection
            this.$nextTick(() => {
                const modalComponent = this.$refs.systemModal;
                if (modalComponent) {
                    modalComponent.setPreselectedType(integration_type);
                }
            });
        },
        addFile(){
            // var modal = new bootstrap.Modal(document.getElementById('file-modal'));
            // modal.show();
        },
        handlePopState(event) {
            this.setScreen();
            this.renderChart(false);
        },
        updateConnection(conn) {
            this.connection_selected = conn;
            var modal = new bootstrap.Modal(document.getElementById('connections-setting-system-modal'));
            modal.show();
        },
        addConnection(connection) {
            // Add the new connection to the local connections array
            var index = this.local_connections.findIndex(conn => conn.id == connection.id);
            if(index >= 0){
                this.local_connections[index] = connection;
            } else {
                this.local_connections.push(connection);
            }
            // Update the connected integrations list
            this.setConnectedIntegrations();
            // Force update to refresh the UI
            this.$forceUpdate();
        },
        resetModal() {
            // Reset the connection_selected state when modal is closed
            this.connection_selected = null;
        },
        closeFileModal() {
            const myModalEl = document.getElementById('file-modal');
            const modal = bootstrap.Modal.getInstance(myModalEl);
            modal.hide();

            // Ensure backdrop removal
            myModalEl.addEventListener('hidden.bs.modal', () => {
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                    backdrop.parentNode.removeChild(backdrop);
                }
            }, { once: true });
        },
        handleDeleteConnection(connection) {
            // Remove the connection from the local connections array
            const index = this.local_connections.findIndex(conn => conn.id === connection.id);
            if (index >= 0) {
                this.local_connections.splice(index, 1);
            }
            
            // Update the connected integrations list
            this.setConnectedIntegrations();
            
            // Navigate back to the selection view
            this.backToSelection();
            
            // Force update to refresh the UI
            this.$forceUpdate();
        }
    }
});
</script>
